import { render, staticRenderFns } from "./YourRegistration.vue?vue&type=template&id=1bf7b935"
import script from "./YourRegistration.vue?vue&type=script&lang=js"
export * from "./YourRegistration.vue?vue&type=script&lang=js"
import style0 from "./YourRegistration.vue?vue&type=style&index=0&id=1bf7b935&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports